export const COOKIE_OPTIONS = {
  secure: true,
  sameSite: 'strict',
}

export const CSRF_HEADER = 'X-CSRF-Token'